export default "__VITE_ASSET__BP0eJDiu__"